/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    imageError = require('../utilities/imageError'),
    configuration = require('../utilities/configuration'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'carousel-item'
    },
    tagName: 'div',
    template: templates.imagesCarouselItem,
    initialize: function () {
        this.templateContext = _.extend({index: this.options.index + 1, count: this.options.count}, this.model.toJSON());
        this.listenTo(this.model, 'change', _.bind(function () {
            this.render();
        }, this));
    },
    onRender: function () {
        // console.log(this.model.id);
        if (this.model.collection.indexOf(this.model) === 0) {
            this.$el.addClass('active');
        }
        jQuery('img.fragile', this.$el).on('error', imageError);
    }
});
